import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/components/ThemeContext";

export default function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={toggleTheme}
      className="relative w-9 h-9 rounded-sm flex items-center justify-center transition-colors"
      style={{
        backgroundColor: 'var(--rhz-surface)',
        border: '1px solid var(--rhz-border)',
        color: 'var(--rhz-text-secondary)',
      }}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
